module.exports = __webpack_public_path__ + "img/2.a32a5569.png";